// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_CAT_FOOTWEAR = "Obuv detsk\u00e1";
export const BZ2_CAT_PRAMS = "Ko\u010d\u00edky a fusaky";
export const BZ2_CAT_TOYS = "Hra\u010dky a hry";
export const HOMEPAGE_MORE_CATEGORIES = "\u010eal\u0161ie kateg\u00f3rie";
export const HOMEPAGE_SEARCH_IN_BAZAAR = "H\u013eadaj v baz\u00e1ri";
export const HOMEPAGE_SEARCH_IN_BAZAAR_PLACEHOLDER = "H\u013eadaj inzer\u00e1ty v baz\u00e1ri";
